import { ark } from './utils';
import { listPlaceholders } from './usePlaceholders';

export const importPlaceholderGroup = (model) => {
    const _model = {
        typeName: ark(model, 'typeName', 'PlaceholderDefinitionResponse'),
        name: ark(model, 'name', ''),
        description: ark(model, 'description', ''),
        model: ark(model, 'model', []),
        sample: ark(model, 'sample', []),
        uiConfig: ark(model, 'uiConfig', {}),
        placeholderDefinitionId: ark(model, 'placeholderDefinitionId', '0'),
        type: ark(model, 'type', 'SIMPLE'),
    };
    return _model;
};

export const importTemplateVersion = (templateVersionModel, templateEditModel, newModel) => {
    console.log('useImportExport.js importTemplateVersion newModel', newModel);
    console.log('useImportExport.js importTemplateVersion templateEditModel', templateEditModel);
    templateVersionModel.typeName = ark(newModel, 'typeName', 'TemplateVersionResponse');
    templateVersionModel.templateId = ark(templateVersionModel, 'templateId', '0');
    templateVersionModel.langCode = ark(newModel, 'langCode', 'CS');
    templateVersionModel.version = ark(newModel, 'version', '1.0');
    templateVersionModel.dmsId = ark(newModel, 'dmsId', null);
    templateVersionModel.subject = ark(newModel, 'subject', '');
    templateVersionModel.source = ark(newModel, 'source', '');
    templateVersionModel.sourceInline = ark(newModel, 'sourceInline', '');
    templateVersionModel.changeLog = ark(newModel, 'changeLog', '');
    templateVersionModel.state = 'DRAFT';
    templateVersionModel.uiConfig = ark(newModel, 'uiConfig', {});
    templateEditModel.template.body = newModel.uiConfig.template.body;
    templateEditModel.template.head = newModel.uiConfig.template.head;
    templateEditModel.template.meta = newModel.uiConfig.template.meta;
    delete templateVersionModel.templateVersionId;
    return templateVersionModel;
};

export const exportPlaceholderGroup = (model) => {
    const u = JSON.parse(ark(model, 'uiConfig', '{}'));
    const m = ark(model, 'model', '[]');
    const s = ark(model, 'sample', '[]');
    if (u == null) {
        model.uiConfig = {};
    }
    if (m == null) {
        model.model = [];
    }
    if (s == null) {
        model.sample = [];
    }
    model.uiConfig = u;
    delete model.created;
    delete model.createdBy;
    delete model.updated;
    delete model.updatedBy;
    delete model.placeholderDefinitionId;
    return model;
};

export const exportTemplateVersion = (model) => {
    const u = ark(model, 'uiConfig', {});
    if (u == null) {
        model.uiConfig = '{}';
    }
    model.uiConfig = JSON.parse(model.uiConfig);
    delete model.created;
    delete model.createdBy;
    delete model.updated;
    delete model.updatedBy;
    delete model.templateVersionId;
    return model;
};

export const checkPlaceholderGroup = (groupName) => {
    const find = listPlaceholders({
        name: groupName,
    });
    const result = {
        status: typeof find === 'object' && find.length > 0,
        message: 'Group not found',
        data: {},
    };
    if (result.status === true) {
        result.data = find[0];
        result.message = 'Group found';
    }
    return result;
};

export const checkPlaceholderGroupItems = (usedPlaceholders, existingPlaceholders) => {
    const result = {
        status: true,
        message: 'Group not found',
        valid: [],
        missing: [],
    };

    usedPlaceholders.map((item) => {
        if (!existingPlaceholders.includes(item)) {
            result.status = false;
            result.missing.push(item);
        } else {
            result.valid.push(item);
        }
    });
    return result;
};

export const useImportExport = () => {
    return {
        exportPlaceholderGroup: exportPlaceholderGroup,
        exportTemplateVersion: importTemplateVersion,
        importPlaceholderGroup: importPlaceholderGroup,
        importTemplateVersion: importTemplateVersion,
        checkPlaceholderGroup: checkPlaceholderGroup,
        checkPlaceholderGroupItems: checkPlaceholderGroupItems,
    };
};

export default useImportExport;
